"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export interface WithdrawalConsentState {
  earlyStartConsent: boolean;
  withdrawalLossAcknowledged: boolean;
}

export const INITIAL_WITHDRAWAL_CONSENT_STATE: WithdrawalConsentState = {
  earlyStartConsent: false,
  withdrawalLossAcknowledged: false,
};

export function isWithdrawalConsentComplete(state: WithdrawalConsentState): boolean {
  return state.earlyStartConsent && state.withdrawalLossAcknowledged;
}

/**
 * Zwei separate, gesetzlich vorgeschriebene Bestaetigungen fuer den kuenftigen
 * Abo-Checkout (backlog.md -> Feedback-Runde 19 Punkt 21, TODO(dev) in
 * app/widerruf/page.tsx): § 356 Abs. 6 BGB verlangt bei digitalen Inhalten ohne
 * koerperlichen Datentraeger ZWEI getrennte Bestaetigungen, bevor das Widerrufsrecht
 * durch sofortigen Vertragsbeginn vorzeitig erlischt - (1) ausdrueckliche Zustimmung
 * zum vorzeitigen Beginn, (2) Kenntnisnahme, dass dadurch das Widerrufsrecht verloren
 * geht (Art. 246a § 1 Abs. 3 EGBGB). Absichtlich zwei UNABHAENGIGE Checkboxen statt
 * einer kombinierten - beide muessen einzeln angehakt werden, eine vorausgefuellte
 * Zustimmung darf nie unbemerkt vorgetaeuscht werden koennen.
 *
 * Reiner Anzeige-/Zustands-Baustein ohne eigenen Checkout-Kontext (der
 * Stripe-Checkout selbst ist noch nicht gebaut, siehe backlog.md ->
 * "Monetarisierung"): der aufrufende Checkout-Flow uebergibt state/onChange und
 * entscheidet selbst, ob/wie der "Weiter"-Button an isWithdrawalConsentComplete()
 * gegated wird.
 */
export function WithdrawalConsentCheckboxes({
  state,
  onChange,
  className,
}: {
  state: WithdrawalConsentState;
  onChange: (next: WithdrawalConsentState) => void;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <label className="flex items-start gap-2.5 text-sm text-ink-secondary">
        <Checkbox
          checked={state.earlyStartConsent}
          onCheckedChange={(checked) => onChange({ ...state, earlyStartConsent: checked === true })}
          className="mt-0.5"
        />
        <span>
          Ich stimme ausdrücklich zu, dass Erikonomie bereits vor Ablauf der
          14-tägigen Widerrufsfrist mit der Vertragserfüllung (Freischaltung des
          Abonnements) beginnt.
        </span>
      </label>
      <label className="flex items-start gap-2.5 text-sm text-ink-secondary">
        <Checkbox
          checked={state.withdrawalLossAcknowledged}
          onCheckedChange={(checked) => onChange({ ...state, withdrawalLossAcknowledged: checked === true })}
          className="mt-0.5"
        />
        <span>
          Ich habe zur Kenntnis genommen, dass ich mein Widerrufsrecht dadurch
          verliere, sobald Erikonomie den Vertrag vollständig erfüllt hat (§ 356
          Abs. 6 BGB).
        </span>
      </label>
    </div>
  );
}
